import { useTranslation } from 'react-i18next';

/**
 * "iOS filter" tag (2026-10-07): an iPhone call screening assistant answered
 * this call ("enregistrez votre nom et le motif de votre appel"), recorded as
 * amd_result 'call_screening'. Shown beside the status, never in its place.
 */
export function isCallScreening(call: { amd_result?: string | null } | null | undefined): boolean {
  return call?.amd_result === 'call_screening';
}

export default function CallScreeningTag({ call }: { call: { amd_result?: string | null } | null | undefined }) {
  const { t } = useTranslation('dialer');
  if (!isCallScreening(call)) return null;
  return (
    <span
      className="inline-flex items-center text-[11px] text-muted-foreground/80"
      title={t('dialer:callScreening.tagHint')}
    >
      {t('dialer:callScreening.tag')}
    </span>
  );
}
